import { useEffect, useState } from "react";
import GetUserInfoService from "../service/GetUserInfoService";
import useApiStatus from "./useApiStatus";

const useExtracoinInfo = () => {
  const [extracoinInfo, setExtracoinInfo] = useState();
  const { isLoading, setIsLoading, retryFetch, setRetryFetch } = useApiStatus({ isLoading: true });

  const getUserInfoService = new GetUserInfoService();

  const loadExtracoinInfo = () => {
    getUserInfoService
      .getExtracoinInfo(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      )
      .then((res) => {
        if (res.messageCode === 200001) setExtracoinInfo(res.result);
        else {
          localStorage.removeItem("__extraconomy_token");
          localStorage.removeItem("__extraconomy_username");
          window.location.replace("/login");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    loadExtracoinInfo();
    return () => {
      setIsLoading();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (retryFetch) {
      loadExtracoinInfo();
      setRetryFetch(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retryFetch]);

  return {
    extracoinInfo,
    isLoading,
    retryFetch,
    setRetryFetch,
  };
};

export default useExtracoinInfo;
